import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    list: [],
    totalCount: 0,
    pagination: {
      page: 1,
      size: 25
    }
  },
  mutations: {
    setList(state, payload) {
      state.list = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    }
  }
};

appStore.registerModule('leagueRecord', store);
